import { Action } from 'redux';
import {
  IAuction,
  ICapacityReturnRequest,
  ICapacityReturnResponse,
  ISourceAuction
} from '../../services';

export enum ReturnsActionEnum {
  ShowReturnsPanel = '@@Return/Show_Returns_Panel',
  HideReturnsPanel = '@@Return/Hide_Returns_Panel',
  FetchCapacityReturns = '@@Return/Fetch_Capacity_Returns',
  FetchCapacityReturnsSuccess = '@@Return/Fetch_Capacity_Returns_Success',
  FetchCapacityReturnsFailed = '@@Return/Fetch_Capacity_Returns_Failed',
  SubmitCapacityReturn = '@@Return/Submit_Capacity_Return',
  SubmitCapacityReturnSuccess = '@@Return/Submit_Capacity_Return_Success',
  SubmitCapacityReturnFailed = '@@Return/Submit_Capacity_Return_Failed'
}

export interface IReturnsState {
  showReturnsPanel: boolean;
  auction?: IAuction;
  sourceAuctions: ISourceAuction[];
  isLoading: boolean;
  errorMessage: string;
  returnSubmissionResponse?: ICapacityReturnResponse;
  isSubmitting: boolean;
}

export interface IShowReturnsPanelAction
  extends Action<typeof ReturnsActionEnum.ShowReturnsPanel> {
  auction: IAuction;
}

export interface IHideReturnsPanelAction
  extends Action<typeof ReturnsActionEnum.HideReturnsPanel> {}

export interface IFetchCapacityReturnsAction
  extends Action<typeof ReturnsActionEnum.FetchCapacityReturns> {
  auction: IAuction;
}

export interface IFetchCapacityReturnsSuccessAction
  extends Action<typeof ReturnsActionEnum.FetchCapacityReturnsSuccess> {
  sourceAuctions: ISourceAuction[];
  auction: IAuction;
}

export interface IFetchCapacityReturnsFailedAction
  extends Action<typeof ReturnsActionEnum.FetchCapacityReturnsFailed> {
  error: string;
}

export interface ISubmitCapacityReturnAction
  extends Action<typeof ReturnsActionEnum.SubmitCapacityReturn> {
  request: ICapacityReturnRequest;
}

export interface ISubmitCapacityReturnSuccessAction
  extends Action<typeof ReturnsActionEnum.SubmitCapacityReturnSuccess> {
  response: ICapacityReturnResponse;
}

export interface ISubmitCapacityReturnFailedAction
  extends Action<typeof ReturnsActionEnum.SubmitCapacityReturnFailed> {
  error: string;
}

export type ReturnsActions =
  | IShowReturnsPanelAction
  | IHideReturnsPanelAction
  | IFetchCapacityReturnsAction
  | IFetchCapacityReturnsSuccessAction
  | IFetchCapacityReturnsFailedAction
  | ISubmitCapacityReturnAction
  | ISubmitCapacityReturnSuccessAction
  | ISubmitCapacityReturnFailedAction;
